import React from "react";
import classNames from "classnames";

import { Props } from "./types";
import { NumberIcon } from "./numberIcon";
import { TextIcon } from "./textIcon";
import { DateIcon } from "./dateIcon";
import { ListIcon } from "./listIcon";
import { DocumentIcon } from "./documentIcon";
import { LinkIcon } from "./linkIcon";
import { ResourceIcon } from "./resourceIcon";
import { RichTextIcon } from "./richTextIcon";
import styles from "./styles.scss";

function SecondaryCriteriaIcon(props: Props) {
  return props.type === "number" ? (
    <NumberIcon {...props} />
  ) : props.type === "date" ? (
    <DateIcon {...props} />
  ) : props.type === "document" ? (
    <DocumentIcon {...props} />
  ) : props.type === "link" ? (
    <LinkIcon {...props} />
  ) : props.type === "list" ? (
    <ListIcon
      {...props}
      className={classNames(styles.listIcon, {
        [`${props.className}`]: !!props.className,
      })}
    />
  ) : props.type === "resource" ? (
    <ResourceIcon {...props} />
  ) : props.type === "richText" ? (
    <RichTextIcon {...props} />
  ) : (
    <TextIcon {...props} />
  );
}

export { SecondaryCriteriaIcon };
